import { render } from "./scoreDetail.vue?vue&type=template&id=6a6ad162"
import script from "./scoreDetail.vue?vue&type=script&lang=js"
export * from "./scoreDetail.vue?vue&type=script&lang=js"

import "./scoreDetail.vue?vue&type=style&index=0&id=6a6ad162&lang=scss"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/game/peopleRank/scoreDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a6ad162"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a6ad162', __exports__)) {
    console.log('reload')
    api.reload('6a6ad162', __exports__)
  }
  
  module.hot.accept("./scoreDetail.vue?vue&type=template&id=6a6ad162", () => {
    console.log('re-render')
    api.rerender('6a6ad162', render)
  })

}


export default __exports__